// @flow
import React from 'react'

require('./styles.scss')

// let intro = require('./cover-desktop.mp4')
// let introMobile = require('./cover-mobile.mp4')
// let introWebM = require('./cover-desktop.webm')
// let introWebMmobile = require('./cover-mobile.webm')

// let poster = require('./test.svg')
// let posterMobile = require('./cover-mobile.jpg')

export function cover(props: { title: string, subtitle: string }) {
  const isMobile = window.innerWidth < 600
  const isTablet = window.innerWidth < 1025
  // const isIOS9 = /iPhone OS [6789]_/.test(navigator.userAgent)

  return (
    <div className='cover'>

      <div className='ui vertical fitted segment mobile only'
          
          style={{
            padding: '0 0',
            backgroundImage: `url(${require('./mobile.gif')})`,
            // : `url(${require('./imgs/test-2.svg')})`,
            backgroundPosition: 'bottom center',
            height: '100%',
            backgroundSize: '100% auto',
            backgroundRepeat: 'no-repeat',

          }}
          >
      </div>

      {/* <img 
      src={isMobile ? posterMobile : poster} 
      alt='' 
      className='fallback' /> */}

      <div className='top gradient' />
      <div
        className='ui mobile only'
        style={{
          position: 'absolute',
          top: '12vh',
          left: 0,
          width: '100vw'
        }}
      >
        <div className='ui text container mobile only'>
          <div className=''>
            <h1
              className='ui left aligned header'
              style={{
                textAlign: 'left'
              }}
            >
              {props.title}
            </h1>
            {/* <div className='sub header'>{props.subtitle}</div> */}
          </div>
        </div>
      </div>

      <div className='ui vertical fitted segment tabletOnly'
          
          style={{
            padding: '0 0',
            backgroundImage: `url(${require('./tablet.gif')})`,
            // : `url(${require('./imgs/test-2.svg')})`,
            backgroundPosition: 'bottom center',
            height: '100%',
            // paddingBottom: '107.56%',
            backgroundSize: '100% auto',
            backgroundRepeat: 'no-repeat',
            

          }}
          >
      </div>

    <div
      className='tabletOnly'
      style={{
        position: 'absolute',
        top: '6em',
        left: 0,
        width: '100vw'
      }}
    >
      
      <div className='ui left aligned container'>
        <div className='ui text container'>
          <h1 className='ui header' style={{}}>
            {props.title}
            {/* <div className='sub header'>{props.subtitle}</div> */}
          </h1>
        </div>
      </div>
    </div>



      <div className='ui vertical fitted segment desktopOnly'
          
            style={{
              padding: '0 0',
              backgroundImage: `url(${require('./desktop.gif')})`,
              // : `url(${require('./imgs/test-2.svg')})`,
              backgroundPosition: 'bottom center',
              height: '100%',
              // paddingBottom: '58%',
              backgroundSize: '100% auto',
              backgroundRepeat: 'no-repeat',

            }}
            >
        </div>

      <div
        className='desktopOnly'
        style={{
          position: 'absolute',
          top: '6em',
          left: 0,
          width: '100vw',

          // height: '60vh'
        }}
      >
        
        <div className='ui left aligned container mobile hidden tablet hidden'>
          <div className='ui container'>
            <h1 className='ui header' style={{}}>
              {props.title}
              {/* <div className='sub header'>{props.subtitle}</div> */}
            </h1>
          </div>
        </div>
      </div>
    </div>
  )
}

export default cover
